<template>
  <div class="user-info-wrapper">
    <div class="user-info">
      <div class="user-info-content">
        <div class="info-img">
          <img v-lazy="userInfo.headImg" />
        </div>
        <div class="user-info-detail">
          <p class="user-name-grade">
            <span class="name" v-if="userInfo.userName">{{ userInfo.userName }}</span>
            <i class="dirver" v-if="userInfo.grade.gradeName"></i>
            <span class="grade" v-if="userInfo.grade.gradeName">{{ userInfo.grade.gradeName }}</span>
          </p>
          <p v-if="userUnit">{{ userUnit }}</p>
        </div>
      </div>
    </div>
    <div class="num-wrapper flex">
      <div class="flex-text">
        <span class="num">{{ userInfo.worksPassNum | numFilter }}</span>
        <div class="label">
          <div class="text">作品总数</div>
          <div class="icon"></div>
        </div>
      </div>
      <div class="line" v-if="!hidePraise"></div>
      <div class="flex-text" v-if="!hidePraise">
        <span class="num">{{ userInfo.likeNum | numFilter }}</span>
        <div class="label">
          <div class="text">总点赞数</div>
          <div class="icon"></div>
        </div>
      </div>
    </div>
    <div class="icon icon-back" @click="handleBack" v-if="!systemInfo.isNfPlus"></div>
  </div>
</template>

<script>
import resolveUserUnit from "@/utils/resolveUserUnit"
import { mapGetters } from "vuex"

export default {
  props: {
    userInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  filters: {
    numFilter(val) {
      if (val) {
        // 分割后遍历
        val += ""
        let strList = val.split("")
        let num = strList.length % 3
        let value = ""
        strList.forEach((item, index) => {
          value += item
          // index不能是最后一位值,并且减去余数后能整除3
          if (index != strList.length - 1 && !((index + 1 - num) % 3)) {
            value += ","
          }
        })
        return value
      } else {
        return 0
      }
    }
  },
  methods: {
    handleBack() {
      const isFirstRoute = window.routerArr && window.routerArr.length < 2
      if (isFirstRoute) {
        this.$router.replace({ path: "/" })
      } else {
        this.$router.go(-1)
      }
    }
  },
  computed: {
    ...mapGetters({
      systemInfo: "systemInfo",
      hidePraise: "activityInfo/hidePraise"
    }),
    userUnit() {
      return resolveUserUnit(this.userInfo)
    }
  }
}
</script>

<style lang="scss" scoped>
.user-info-wrapper {
  height: 3.5rem;
  width: 100%;
  position: relative;
  .user-info {
    height: 2.5rem;
    width: 100%;
    background: url("../../../../assets/images/works_bg.png") no-repeat center;
    background-size: 100% 100%;
    overflow: hidden;
    font-family: PingFangSC-Regular;
    .user-info-content {
      display: flex;
      height: 1rem;
      width: 100%;
      padding-left: 0.84rem;
      margin-top: 0.54rem;
      .info-img {
        height: 1rem;
        width: 1rem;
        border-radius: 100% 100%;
        border: 1px solid rgba(255, 255, 255, 0.8);
        flex: none;
        img {
          display: block;
          height: 100%;
          width: 100%;
          border-radius: 100% 100%;
        }
      }
      .user-info-detail {
        display: inline-block;
        margin-left: 0.3rem;
        vertical-align: top;
        overflow: hidden;
        .user-name-grade {
          padding-right: 0.3rem;
          .name,
          .grade {
            flex: none;
          }
          .name {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            flex: unset;
          }
        }
      }
      p {
        height: 0.5rem;
        margin: 0;
        font-size: 0.24rem;
        color: #fff;
        display: flex;
        align-items: center;
      }
      .name {
        font-size: 0.32rem;
      }
      .dirver {
        width: 1px;
        height: 0.18rem;
        background-color: #fff;
        margin: 0 0.15rem;
      }
      .grade {
        line-height: 0.6rem;
      }
    }
  }
  .num-wrapper {
    height: 1.72rem;
    width: 7.1rem;
    position: absolute;
    left: 0;
    bottom: 0;
    padding-left: 0.4rem;
    background: url("../../../../assets/images/works_quantity_bg.png") no-repeat center;
    background-size: 100% 100%;
    overflow: hidden;
    > div {
      width: 3.04rem;
      height: 1.4rem;
      margin-top: 0.12rem;
      font-size: 0.26rem;
    }
    .line {
      border-left: 1px dotted #d1eaff;
      width: 1px;
      height: 1rem;
      margin-top: 0.35rem;
    }
    .flex-text {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #666;
      font-family: PingFang-SC-Medium;
      .num {
        color: #389bee;
        font-size: 0.36rem;
        font-family: PingFangSC-Semibold;
      }
      .label {
        position: relative;
        .text {
          position: relative;
          z-index: 100;
        }
        .icon {
          display: block;
          background: url("../../../../assets/images/works_underline.png") no-repeat center;
          background-size: 100%;
          width: 0.8rem;
          height: 0.28rem;
          position: absolute;
          top: 0.2rem;
          left: 50%;
          transform: translate(-50%, 0);
          z-index: 1;
        }
      }
    }
  }
  .flex {
    display: flex;
    justify-content: center;
  }
  .icon-back {
    position: absolute;
    top: 0.1rem;
    left: 0.2rem;
    z-index: 10;
    width: 0.48rem;
    height: 0.64rem;
    background: url("../../../../assets/images/nav_icon_back_white@1x.png") no-repeat center bottom;
    background-size: 0.3rem 0.48rem;
  }
}
</style>
